import { c as _c } from "react/compiler-runtime";
import { AfterDateValueConfig, AfterDateValueConfigKind, AfterFilterValueConfig, BeforeDateValueConfig, BeforeDateValueConfigKind, BeforeFilterValueConfig, BetweenDateValueConfig, BetweenDateValueConfigKind, CohortFilterGranularity, InTheLastValueConfig, InTheLastValueConfigKind, TimeRangeConfig } from '@/api/generated/model';
import React, { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react';
import { formatToHuman } from '@/utils/date.util';
import { ChartDateRange } from '@/domains/chart/components/create-chart/create-chart-settings/chart-date-range';
import { translate } from '@/utils/translations';
import { useAliasedKindName } from '@/contexts/alias';
import { nullableNumberToString } from '@/utils/numbers.util';
import { GenericFilter } from '@/comps/FilterPicker/FilterPicker';
import { useGlobalFiltersContext } from '@/contexts/filters/filter-context';
import { useProjectsContext } from '@/providers/projects-provider';
import { Button as CustomButton } from '@/comps/primitives/button';
import { FILTERS } from '@/models/common/filters';
import SpecialFilterPopover from './special-filter-popver';
import { DateObject } from 'react-multi-date-picker';
import { GenericDatePicker } from '../dates/date-picker';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/comps/primitives/tooltip';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/comps/primitives/select';
import { EditFilterButton } from '@/comps/FilterPicker/EditFilterButton';
import { CalendarDays } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/comps/primitives/popover';
import { Input } from '@/comps/primitives/input';
export type IFilterWhenFields = {
  kind: WhenKind;
  pickedDate: Date | null;
  pickedDates: [Date, Date] | null;
  filter: GenericFilter | null;
  granularity: CohortFilterGranularity;
  number: number;
};
type OnChange = (e: IFilterWhenFields) => void;
export const FilterWhenFields = t0 => {
  const $ = _c(99);
  const {
    onChange,
    initialValues,
    disableSpecialFilters: t1,
    setAdditionalFilter
  } = t0;
  const disableSpecialFilters = t1 === undefined ? false : t1;
  const [kind, setKind] = useState(initialValues.kind);
  const [pickedDate, setPickedDate] = useState(initialValues.pickedDate);
  const [pickedDates, setPickedDates] = useState(initialValues.pickedDates);
  const [granularity, setGranularity] = useState(initialValues.granularity);
  const [number, setNumber] = useState(initialValues.number);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [filters, setFilters] = useState(t2);
  const [popoverOpen, setPopoverOpen] = useState(false);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => {
      setNumber(parseInt(e.target.value));
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleNumberChange = t3;
  let t4;
  if ($[2] !== filters.length || $[3] !== setAdditionalFilter) {
    t4 = () => {
      if (setAdditionalFilter !== undefined) {
        setAdditionalFilter(undefined);
      }
      if (filters.length > 1) {
        setFilters(_temp);
      }
    };
    $[2] = filters.length;
    $[3] = setAdditionalFilter;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== filters || $[6] !== setAdditionalFilter) {
    t5 = [filters, setFilters, setAdditionalFilter];
    $[5] = filters;
    $[6] = setAdditionalFilter;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  bb0: {
    if (kind === InTheLastValueConfigKind.in_the_last) {
      let t7;
      if ($[8] !== number) {
        t7 = nullableNumberToString(number);
        $[8] = number;
        $[9] = t7;
      } else {
        t7 = $[9];
      }
      let t8;
      if ($[10] !== t7) {
        t8 = <Input value={t7} type="number" className="h-8 w-10 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" onChange={handleNumberChange} />;
        $[10] = t7;
        $[11] = t8;
      } else {
        t8 = $[11];
      }
      let t9;
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = value => setGranularity(value as CohortFilterGranularity);
        $[12] = t9;
      } else {
        t9 = $[12];
      }
      const t10 = granularity + "s";
      let t11;
      if ($[13] !== t10) {
        t11 = <SelectTrigger className="w-auto"><SelectValue>{t10}</SelectValue></SelectTrigger>;
        $[13] = t10;
        $[14] = t11;
      } else {
        t11 = $[14];
      }
      let t12;
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = <SelectContent><SelectItem value={CohortFilterGranularity.day}>days</SelectItem><SelectItem value={CohortFilterGranularity.week}>weeks</SelectItem><SelectItem value={CohortFilterGranularity.month}>months</SelectItem></SelectContent>;
        $[15] = t12;
      } else {
        t12 = $[15];
      }
      let t13;
      if ($[16] !== granularity || $[17] !== t11) {
        t13 = <Select value={granularity} onValueChange={t9}>{t11}{t12}</Select>;
        $[16] = granularity;
        $[17] = t11;
        $[18] = t13;
      } else {
        t13 = $[18];
      }
      let t14;
      if ($[19] !== t13 || $[20] !== t8) {
        t14 = <>{t8}{t13}</>;
        $[19] = t13;
        $[20] = t8;
        $[21] = t14;
      } else {
        t14 = $[21];
      }
      t6 = t14;
      break bb0;
    } else {
      if (kind === AfterDateValueConfigKind.after) {
        if (!disableSpecialFilters) {
          let t7;
          if ($[22] !== filters || $[23] !== pickedDate) {
            t7 = <SpecialFilterPopover date={pickedDate} setDate={setPickedDate} filters={filters} setFilters={setFilters} />;
            $[22] = filters;
            $[23] = pickedDate;
            $[24] = t7;
          } else {
            t7 = $[24];
          }
          t6 = t7;
          break bb0;
        } else {
          let t7;
          if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = <CalendarDays className="size-4" />;
            $[25] = t7;
          } else {
            t7 = $[25];
          }
          let t8;
          if ($[26] !== pickedDate) {
            t8 = pickedDate ? formatToHuman(pickedDate.valueOf()) : "Select date";
            $[26] = pickedDate;
            $[27] = t8;
          } else {
            t8 = $[27];
          }
          let t9;
          if ($[28] !== t8) {
            t9 = <PopoverTrigger asChild={true}><CustomButton variant="outline">{t7} {t8}</CustomButton></PopoverTrigger>;
            $[28] = t8;
            $[29] = t9;
          } else {
            t9 = $[29];
          }
          let t10;
          if ($[30] !== pickedDate) {
            t10 = pickedDate ? new DateObject(pickedDate) : null;
            $[30] = pickedDate;
            $[31] = t10;
          } else {
            t10 = $[31];
          }
          let t11;
          let t12;
          if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = d => {
              setPickedDate(d?.toDate() || null);
            };
            t12 = () => setPopoverOpen(false);
            $[32] = t11;
            $[33] = t12;
          } else {
            t11 = $[32];
            t12 = $[33];
          }
          let t13;
          if ($[34] !== t10) {
            t13 = <PopoverContent><GenericDatePicker value={t10} onChange={t11} onClose={t12} /></PopoverContent>;
            $[34] = t10;
            $[35] = t13;
          } else {
            t13 = $[35];
          }
          let t14;
          if ($[36] !== popoverOpen || $[37] !== t13 || $[38] !== t9) {
            t14 = <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>{t9}{t13}</Popover>;
            $[36] = popoverOpen;
            $[37] = t13;
            $[38] = t9;
            $[39] = t14;
          } else {
            t14 = $[39];
          }
          t6 = t14;
          break bb0;
        }
      } else {
        if (kind === BetweenDateValueConfigKind.between) {
          let t7;
          if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = <CalendarDays className="size-4" />;
            $[40] = t7;
          } else {
            t7 = $[40];
          }
          let t8;
          if ($[41] !== pickedDates) {
            t8 = pickedDates ? `${formatToHuman(pickedDates[0].valueOf())} - ${formatToHuman(pickedDates[1].valueOf())}` : "Select dates";
            $[41] = pickedDates;
            $[42] = t8;
          } else {
            t8 = $[42];
          }
          let t9;
          if ($[43] !== t8) {
            t9 = <PopoverTrigger asChild={true}><CustomButton variant="outline">{t7}{" "}{t8}</CustomButton></PopoverTrigger>;
            $[43] = t8;
            $[44] = t9;
          } else {
            t9 = $[44];
          }
          let t10;
          if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = <PopoverContent><ChartDateRange onChange={d_0 => {
                if (d_0) {
                  setPickedDates([d_0[0].toDate(), d_0[1].toDate()]);
                }
              }} onClose={() => setPopoverOpen(false)} /></PopoverContent>;
            $[45] = t10;
          } else {
            t10 = $[45];
          }
          let t11;
          if ($[46] !== popoverOpen || $[47] !== t9) {
            t11 = <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>{t9}{t10}</Popover>;
            $[46] = popoverOpen;
            $[47] = t9;
            $[48] = t11;
          } else {
            t11 = $[48];
          }
          t6 = t11;
          break bb0;
        } else {
          if (kind === BeforeDateValueConfigKind.before) {
            if (!disableSpecialFilters) {
              let t7;
              if ($[49] !== filters || $[50] !== pickedDate) {
                t7 = <SpecialFilterPopover date={pickedDate} setDate={setPickedDate} filters={filters} setFilters={setFilters} />;
                $[49] = filters;
                $[50] = pickedDate;
                $[51] = t7;
              } else {
                t7 = $[51];
              }
              t6 = t7;
              break bb0;
            } else {
              let t7;
              if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
                t7 = <CalendarDays className="size-4" />;
                $[52] = t7;
              } else {
                t7 = $[52];
              }
              let t8;
              if ($[53] !== pickedDate) {
                t8 = pickedDate ? formatToHuman(pickedDate.valueOf()) : "Select date";
                $[53] = pickedDate;
                $[54] = t8;
              } else {
                t8 = $[54];
              }
              let t9;
              if ($[55] !== t8) {
                t9 = <PopoverTrigger asChild={true}><CustomButton variant="outline">{t7} {t8}</CustomButton></PopoverTrigger>;
                $[55] = t8;
                $[56] = t9;
              } else {
                t9 = $[56];
              }
              let t10;
              if ($[57] !== pickedDate) {
                t10 = pickedDate ? new DateObject(pickedDate) : null;
                $[57] = pickedDate;
                $[58] = t10;
              } else {
                t10 = $[58];
              }
              let t11;
              let t12;
              if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
                t11 = d_1 => {
                  setPickedDate(d_1?.toDate() || null);
                };
                t12 = () => setPopoverOpen(false);
                $[59] = t11;
                $[60] = t12;
              } else {
                t11 = $[59];
                t12 = $[60];
              }
              let t13;
              if ($[61] !== t10) {
                t13 = <PopoverContent><GenericDatePicker value={t10} onChange={t11} onClose={t12} /></PopoverContent>;
                $[61] = t10;
                $[62] = t13;
              } else {
                t13 = $[62];
              }
              let t14;
              if ($[63] !== popoverOpen || $[64] !== t13 || $[65] !== t9) {
                t14 = <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>{t9}{t13}</Popover>;
                $[63] = popoverOpen;
                $[64] = t13;
                $[65] = t9;
                $[66] = t14;
              } else {
                t14 = $[66];
              }
              t6 = t14;
              break bb0;
            }
          }
        }
      }
    }
    t6 = undefined;
  }
  const middleFields = t6;
  let t7;
  if ($[67] !== filters[0] || $[68] !== filters.length || $[69] !== granularity || $[70] !== kind || $[71] !== number || $[72] !== onChange || $[73] !== pickedDate || $[74] !== pickedDates) {
    t7 = () => {
      onChange({
        kind,
        pickedDate,
        pickedDates,
        granularity,
        number: number || 0,
        filter: filters.length > 0 ? filters[0] : null
      });
    };
    $[67] = filters[0];
    $[68] = filters.length;
    $[69] = granularity;
    $[70] = kind;
    $[71] = number;
    $[72] = onChange;
    $[73] = pickedDate;
    $[74] = pickedDates;
    $[75] = t7;
  } else {
    t7 = $[75];
  }
  let t8;
  if ($[76] !== filters || $[77] !== granularity || $[78] !== kind || $[79] !== number || $[80] !== onChange || $[81] !== pickedDate || $[82] !== pickedDates) {
    t8 = [kind, pickedDate, pickedDates, granularity, number, onChange, filters];
    $[76] = filters;
    $[77] = granularity;
    $[78] = kind;
    $[79] = number;
    $[80] = onChange;
    $[81] = pickedDate;
    $[82] = pickedDates;
    $[83] = t8;
  } else {
    t8 = $[83];
  }
  useEffect(t7, t8);
  let t9;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = value_0 => setKind(value_0 as WhenKind);
    $[84] = t9;
  } else {
    t9 = $[84];
  }
  let t10;
  if ($[85] !== kind) {
    t10 = translate("date_config_kind", kind);
    $[85] = kind;
    $[86] = t10;
  } else {
    t10 = $[86];
  }
  let t11;
  if ($[87] !== t10) {
    t11 = <SelectTrigger className="w-auto"><SelectValue>{t10}</SelectValue></SelectTrigger>;
    $[87] = t10;
    $[88] = t11;
  } else {
    t11 = $[88];
  }
  let t12;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SelectItem value={InTheLastValueConfigKind.in_the_last}>{translate("date_config_kind", InTheLastValueConfigKind.in_the_last)}</SelectItem>;
    $[89] = t12;
  } else {
    t12 = $[89];
  }
  let t13;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SelectItem value={AfterDateValueConfigKind.after}>{translate("date_config_kind", AfterDateValueConfigKind.after)}</SelectItem>;
    $[90] = t13;
  } else {
    t13 = $[90];
  }
  let t14;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SelectItem value={BetweenDateValueConfigKind.between}>{translate("date_config_kind", BetweenDateValueConfigKind.between)}</SelectItem>;
    $[91] = t14;
  } else {
    t14 = $[91];
  }
  let t15;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SelectContent>{t12}{t13}{t14}<SelectItem value={BeforeDateValueConfigKind.before}>{translate("date_config_kind", BeforeDateValueConfigKind.before)}</SelectItem></SelectContent>;
    $[92] = t15;
  } else {
    t15 = $[92];
  }
  let t16;
  if ($[93] !== kind || $[94] !== t11) {
    t16 = <Select value={kind} onValueChange={t9}>{t11}{t15}</Select>;
    $[93] = kind;
    $[94] = t11;
    $[95] = t16;
  } else {
    t16 = $[95];
  }
  let t17;
  if ($[96] !== middleFields || $[97] !== t16) {
    t17 = <div className="flex items-center gap-1">{t16}{middleFields}</div>;
    $[96] = middleFields;
    $[97] = t16;
    $[98] = t17;
  } else {
    t17 = $[98];
  }
  return t17;
};
type WhenKind = InTheLastValueConfigKind | BetweenDateValueConfigKind | AfterDateValueConfigKind | BeforeDateValueConfigKind;
export const WhenForm = t0 => {
  const $ = _c(40);
  const {
    onApply,
    title,
    timeRange: propTimeRange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      granularity: CohortFilterGranularity.day,
      kind: InTheLastValueConfigKind.in_the_last,
      number: 1,
      filter: null,
      pickedDate: null,
      pickedDates: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [fields, setFields] = useState(t1);
  const [additionalFilter, setAdditionalFilter] = useState(undefined);
  const {
    timeRange: globalTimeRange
  } = useGlobalFiltersContext();
  const {
    selectedProject
  } = useProjectsContext();
  const aliasKindName = useAliasedKindName();
  const timeRange = propTimeRange || globalTimeRange;
  let t2;
  if ($[1] !== aliasKindName) {
    t2 = aliasKindName(FILTERS.columnTopic) ?? translate("filter", FILTERS.columnTopic);
    $[1] = aliasKindName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const topicFilterLabel = t2;
  let t3;
  if ($[3] !== aliasKindName) {
    t3 = aliasKindName(FILTERS.columnIntent) ?? translate("filter", FILTERS.columnIntent);
    $[3] = aliasKindName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const intentFilterLabel = t3;
  let t4;
  if ($[5] !== additionalFilter || $[6] !== fields) {
    t4 = whenFieldsToConfig(fields, additionalFilter);
    $[5] = additionalFilter;
    $[6] = fields;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const config = t4;
  let t5;
  if ($[8] !== additionalFilter || $[9] !== config || $[10] !== onApply) {
    t5 = () => {
      if (config) {
        onApply(config, additionalFilter);
      }
    };
    $[8] = additionalFilter;
    $[9] = config;
    $[10] = onApply;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const apply = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value => {
      if (value === "null") {
        setAdditionalFilter(undefined);
        return;
      }
      setAdditionalFilter({
        column: value,
        values: [],
        is_exclude: false
      } as GenericFilter);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleSelect = t6;
  let t7;
  if ($[13] !== config?.value || $[14] !== title) {
    t7 = title && <p className="text-sm">{!(config?.value as GenericFilter)?.column ? title : "Users who have interactions"}</p>;
    $[13] = config?.value;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== fields) {
    t8 = <FilterWhenFields setAdditionalFilter={setAdditionalFilter} onChange={setFields} initialValues={fields} />;
    $[16] = fields;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = additionalFilter && "and";
  let t10;
  if ($[18] !== additionalFilter?.column || $[19] !== config?.value || $[20] !== intentFilterLabel || $[21] !== topicFilterLabel) {
    t10 = !(config?.value as GenericFilter)?.column && <Select value={additionalFilter?.column || ""} onValueChange={handleSelect}><SelectTrigger><SelectValue placeholder="+ Select additional filter">{translate("common", additionalFilter?.column || "")}</SelectValue></SelectTrigger><SelectContent><SelectItem value={FILTERS.columnTopic}>{topicFilterLabel}</SelectItem><SelectItem value={FILTERS.columnIntent}>{intentFilterLabel}</SelectItem><SelectItem value="null">Remove filter</SelectItem></SelectContent></Select>;
    $[18] = additionalFilter?.column;
    $[19] = config?.value;
    $[20] = intentFilterLabel;
    $[21] = topicFilterLabel;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = additionalFilter && "is";
  let t12;
  if ($[23] !== additionalFilter || $[24] !== selectedProject?.id || $[25] !== timeRange) {
    t12 = additionalFilter && <EditFilterButton filterKind={additionalFilter.column} title="Global filters" filters={[additionalFilter]} setFilters={v => {
      setAdditionalFilter(v[0]);
    }} projectId={selectedProject?.id} volumeKind="users" timeRange={timeRange} align="right" type="users_table">{additionalFilter.values.length === 0 ? <CustomButton variant="outline">Select value</CustomButton> : <Tooltip><TooltipTrigger className="max-w-25! overflow-hidden text-ellipsis whitespace-nowrap" style={{
          maxWidth: "100px"
        }}><span>{additionalFilter.values.join(", ")}</span></TooltipTrigger><TooltipContent>{additionalFilter.values.join(", ")}</TooltipContent></Tooltip>}</EditFilterButton>;
    $[23] = additionalFilter;
    $[24] = selectedProject?.id;
    $[25] = timeRange;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12 || $[30] !== t9) {
    t13 = <div className="flex items-center gap-1">{t9}{t10}{t11}{t12}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const t14 = !config;
  let t15;
  if ($[32] !== apply || $[33] !== t14) {
    t15 = <CustomButton size="sm" onClick={apply} disabled={t14}>Apply</CustomButton>;
    $[32] = apply;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t15 || $[37] !== t7 || $[38] !== t8) {
    t16 = <div className="flex flex-col gap-2">{t7}{t8}{t13}{t15}</div>;
    $[35] = t13;
    $[36] = t15;
    $[37] = t7;
    $[38] = t8;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};
export const whenFieldsToConfig = ({
  granularity,
  kind,
  number,
  pickedDate,
  pickedDates,
  filter
}: IFilterWhenFields, additionalFilter?: GenericFilter): InTheLastValueConfig | AfterDateValueConfig | BetweenDateValueConfig | BeforeDateValueConfig | BeforeFilterValueConfig | AfterFilterValueConfig | null => {
  if (kind === InTheLastValueConfigKind.in_the_last) {
    return {
      kind,
      value: number,
      granularity,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      additional_filter: additionalFilter as any
    } satisfies InTheLastValueConfig;
  } else if (kind === AfterDateValueConfigKind.after && pickedDate) {
    return {
      kind,
      value: pickedDate?.toISOString(),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      additional_filter: additionalFilter as any
    } satisfies AfterDateValueConfig;
  } else if (kind === AfterDateValueConfigKind.after && filter) {
    return {
      kind,
      value: filter,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      additional_filter: additionalFilter as any
    } satisfies AfterFilterValueConfig;
  } else if (kind === BetweenDateValueConfigKind.between && pickedDates) {
    return {
      kind,
      value: {
        start: pickedDates[0].toISOString(),
        end: pickedDates[1].toISOString()
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      additional_filter: additionalFilter as any
    } satisfies BetweenDateValueConfig;
  } else if (kind === BeforeDateValueConfigKind.before && pickedDate) {
    return {
      kind,
      value: pickedDate?.toISOString(),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      additional_filter: additionalFilter as any
    } satisfies BeforeDateValueConfig;
  } else if (kind === BeforeDateValueConfigKind.before && filter) {
    return {
      kind,
      value: filter,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      additional_filter: additionalFilter as any
    } satisfies BeforeFilterValueConfig;
  }
  return null;
};
function _temp(f) {
  return [f[f.length - 1]];
}